export const ACCESS_TOKEN_COOKIE = "BearerAccessToken";
export const REFRESH_TOKEN_COOKIE = "BearerRefreshToken";
export const PC_REFRESH_TOKEN_COOKIE = "PersonalCloudRefreshToken";
export const PC_ACCESS_TOKEN_COOKIE = "PersonalCloudAccessToken";
export const NEXAR_USER_ID = "NexarUserId";
export const NEXAR_PC_USER_ID = "PersonalCloudUserId";

// Adding new cookies? Don't forget to update the function clearCookies()
